"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPanelFooter;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIDialogFooter = _interopRequireDefault(require("../dialog/UIDialogFooter"));

function UIPanelFooter(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_UIDialogFooter.default, Object.assign({}, rest, {
    className: (0, _classnames.default)('private-panel__footer', className),
    layout: "default"
  }));
}

UIPanelFooter.propTypes = Object.assign({}, _UIDialogFooter.default.propTypes, {
  children: _propTypes.default.node
});
UIPanelFooter.defaultProps = Object.assign({}, _UIDialogFooter.default.defaultProps);
UIPanelFooter.displayName = 'UIPanelFooter';
module.exports = exports.default;